// extracted by mini-css-extract-plugin
export default {"tagContainer":"tagContainer__YjdlZ","tagText":"tagText__NWZkN","icon":"icon__Mzk0O"};